import { HttpRemoveRepository } from "@data/repositories/index";
import { GetRemoveHistoryUseCase } from "@useCases/index";
import { api } from "@data/api";

export default function useRemoveHistory() {
  const getRemoveHistory = async () => {
    const useCase = new GetRemoveHistoryUseCase(new HttpRemoveRepository(api));

    return useCase.execute();
  };
  return {
    getRemoveHistory,
  };
}
